import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
import { isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { css } from "styled-components";

descriptionStyles.wrapper = {
    css: css`
        ${() =>
            isMgbwWebsite()
                ? css`
                      /* Figma 3407:24123: 12px gap between the description and the Swatch Sets link. */
                      margin-bottom: 12px;
                  `
                : ""}
    `,
};
